import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

interface CreateCpaPaymentRequest {
  amount: string;
  email: string;
}

interface CreateCpaPaymentResponse {
  paymentGatewayUrl: string;
}

export const cpaApi = createApi({
  reducerPath: 'cpaApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    createCpaPayment: builder.mutation<CreateCpaPaymentResponse, CreateCpaPaymentRequest>({
      query: (data) => ({
        url: '/cpa/create-payment',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useCreateCpaPaymentMutation,
} = cpaApi; 